import { socialPosts } from "@/mocks/profile";

export default function SocialSection() {
  return (
    <section id="social" className="scroll-mt-20 bg-background-50 py-14 md:py-20">
      <div className="w-full px-4 md:px-8">
        <div className="max-w-3xl mb-10">
          <p className="font-label text-primary-600 text-xs tracking-[0.25em] mb-3">SOCIAL / 动态</p>
          <h2 className="font-heading font-bold text-3xl md:text-4xl text-foreground-950 mb-4">
            社交动态里都聊些什么
          </h2>
          <p className="text-foreground-700 text-sm md:text-base leading-relaxed">
            关于社交平台的讨论，重点往往不在具体事件，而在更新的内容风格与互动氛围。下面按话题方向整理了若干条动态作为示意，
            用于说明大家关注什么，并非逐条核实的内容。
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {socialPosts.map((post) => (
            <article
              key={post.caption}
              className="bg-background-100 border border-background-200 rounded-lg overflow-hidden hover:border-primary-300 transition-colors"
            >
              <div className="w-full aspect-square">
                <img
                  src={post.image}
                  alt=""
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="p-5">
                <div className="flex items-center gap-2 mb-3">
                  <span className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-500 text-background-50 text-sm">
                    <i className="ri-user-3-line" aria-hidden="true"></i>
                  </span>
                  <div className="leading-tight">
                    <p className="font-label text-xs text-foreground-900">松下纱荣子</p>
                    <p className="font-label text-[11px] text-foreground-500">{post.time}</p>
                  </div>
                </div>
                <p className="text-foreground-800 text-sm leading-relaxed mb-4">{post.caption}</p>
                <div className="flex items-center gap-4 text-foreground-500 text-xs font-label">
                  <span className="flex items-center gap-1.5">
                    <i className="ri-heart-3-line text-primary-500 text-base" aria-hidden="true"></i>
                    {post.likes}
                  </span>
                  <span className="flex items-center gap-1.5">
                    <i className="ri-chat-1-line text-base" aria-hidden="true"></i>
                    {post.comments}
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>

        <p className="mt-6 text-foreground-500 text-xs leading-relaxed max-w-3xl">
          说明：以上动态为内容方向示意，用于呈现「社交动态」这一话题类型，页面不提供跳转外部账号的链接。
        </p>
      </div>
    </section>
  );
}